import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

export default class AppNotificationEditor extends Component {

  constructor(props) {
    super(props);
    this.state = this.emptyState();
  }

  emptyState = () => ({
    id: 0,
    name: '',
    priority: false,
    translations: {
      en: { title: '', message: '' },
      de: { title: '', message: '' },
      es: { title: '', message: '' },
      fr: { title: '', message: '' },
      nl: { title: '', message: '' }
    }
  });

  componentDidUpdate(prevProps) {
    if (this.props.data && this.props.data !== prevProps.data) {
      this.setState(this.mapFromProps(this.props.data));
    }

    if (!this.props.data && prevProps.data) {
      this.setState(this.emptyState());
    }
  }

  mapFromProps = (data) => ({
    id: data.id,
    name: data.name || '',
    priority: data.priority || false,
    translations: {
      en: { title: data.englishTitle || '', message: data.englishMessage || '' },
      de: { title: data.germanTitle || '', message: data.germanMessage || '' },
      es: { title: data.spanishTitle || '', message: data.spanishMessage || '' },
      fr: { title: data.frenchTitle || '', message: data.frenchMessage || '' },
      nl: { title: data.dutchTitle || '', message: data.dutchMessage || '' }
    }
  });

  updateField = (lang, field, value) => {
    this.setState(prev => ({
      translations: {
        ...prev.translations,
        [lang]: {
          ...prev.translations[lang],
          [field]: value
        }
      }
    }));
  };

  save = () => {
    const { id, name, priority, translations } = this.state;

    const payload = {
      id,
      name,
      priority,
      translations: Object.keys(translations).map(lang => ({
        languageCode: lang,
        title: translations[lang].title,
        message: translations[lang].message
      }))
    };

    this.props.onSave(payload);
  };

  renderLang = (lang, label, countryCode) => {
    const t = this.state.translations[lang];

    return (
      <Box
        sx={{
          mb: 1.5,
          p: 1.5,
          borderRadius: 2,
          background: 'rgba(255,255,255,0.02)'
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            mb: 1,
            opacity: 0.9,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          <img
            src={`https://flagcdn.com/w20/${countryCode}.png`}
            alt={label}
            style={{
              width: 20,
              height: 14,
              borderRadius: 2,
              objectFit: 'cover'
            }}
          />
          {label}
        </Typography>

        <TextField
          fullWidth
          size="small"
          label="Title"
          value={t.title}
          onChange={e => this.updateField(lang, 'title', e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{
            mb: 1,
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(255,255,255,0.06)',
              borderRadius: 1.5
            }
          }}
        />

        <TextField
          fullWidth
          size="small"
          label="Message"
          multiline
          rows={2}
          value={t.message}
          onChange={e => this.updateField(lang, 'message', e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(255,255,255,0.06)',
              borderRadius: 1.5
            }
          }}
        />
      </Box>
    );
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {this.state.id
            ? "Edit Notification"
            : this.state.priority
              ? "Add Urgent Notification"
              : "Add Notification"}
        </DialogTitle>

        <DialogContent sx={{ pt: 1 }}>

          <TextField
            fullWidth
            size="small"
            label="Notification Name"
            value={this.state.name}
            onChange={e => this.setState({ name: e.target.value })}
            InputLabelProps={{ shrink: true }}
            sx={{
              mt: 2,
              mb: 2,
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'rgba(255,255,255,0.06)',
                borderRadius: 1.5
              }
            }}
          />

          <Divider sx={{ mb: 2 }} />

          {this.renderLang('en', 'English', 'au')}
          {this.renderLang('de', 'German', 'de')}
          {this.renderLang('es', 'Spanish', 'es')}
          {this.renderLang('fr', 'French', 'fr')}
          {this.renderLang('nl', 'Dutch', 'nl')}

        </DialogContent>

        <DialogActions sx={{ px: 2, pb: 2 }}>
          <Button onClick={this.props.onClose}>
            Cancel
          </Button>

          <Button variant="contained" onClick={this.save}>
            {this.state.id ? 'Save' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}